import Breakpoints from "../shared/breakpoints"
import { T } from "../../design-system/atoms/text"
import styled from "styled-components"

export const TypesContainer = styled.div`
  padding: 64px 0;
  border-bottom: 1px solid #2e2e2e26;

  @media (min-width: ${Breakpoints.lg}) {
    padding: 128px 0;
  }
`

export const TiersContainer = styled.div`
  padding: 64px 0;

  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

export const Title = styled.h2`
  ${T.sm.h2`500`}
  grid-column: 1 / -1;
  text-align: center;
  color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2`500`}
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2`500`}
  }
`

export const Description = styled.p`
  grid-column: 1 / -1;
  text-align: center;
  margin-top: 24px;
  ${T.sm.body`400`}
  color: var(--body-text-grey);
  margin-bottom: 48px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body`400`}
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`400`}
    grid-column: 4 / -4;
    margin-bottom: 64px;
  }
`



export const TierCardContainer = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px;
    align-items: start;
  }
`
